import { PHOTO_MODAL_SCREEN_NAMES } from "../utils/constants";
import BaseViewController from "./base-view-controller";
import { withDistinctFieldNames } from "./helpers/distinctFieldNames";
import {
  VIDEO_ROOM_PHOTO_MODAL_FIELD_IDENTIFIER,
  VIDEO_ROOM_PHOTO_MODAL_SCREEN_NAME
} from "../utils/video-room-helper";

class PhotoModalViewController extends BaseViewController {
  constructor(props) {
    super(props);
    const {
      screenParams: { originFieldName }
    } = this.appData;
    const prefix = {
      [VIDEO_ROOM_PHOTO_MODAL_SCREEN_NAME]:
        VIDEO_ROOM_PHOTO_MODAL_FIELD_IDENTIFIER,
      [PHOTO_MODAL_SCREEN_NAMES.pulseRavCase]: originFieldName,
      [PHOTO_MODAL_SCREEN_NAMES.ravCase]: originFieldName,
      [PHOTO_MODAL_SCREEN_NAMES.medicalInfoSection]: "medicalInfo",
      [PHOTO_MODAL_SCREEN_NAMES.emoCase]: originFieldName,
      [PHOTO_MODAL_SCREEN_NAMES.mhNavigatorCase]: originFieldName,
      [PHOTO_MODAL_SCREEN_NAMES.EliteDiagnosticCase]: originFieldName
    }[this.screen.name];
    this.screen = withDistinctFieldNames(this.screen, prefix);
  }

  preprocessScreenData() {
    if (
      Object.values(PHOTO_MODAL_SCREEN_NAMES).includes(this.screen.name) &&
      this.screen.identifier !== PHOTO_MODAL_SCREEN_NAMES.pulseRavCase
    ) {
      this.screen.fields = this.screen.fields.map(field => {
        const duplicateField = { ...field };

        if (duplicateField.type === "formTextField") {
          duplicateField.placeholder ||=
            this.appData.settings.translations.max_250_characters;
        }

        return duplicateField;
      });
    }
  }

  handleButtonClick(action) {
    const {
      screenRefs: { inputFileRef },
      uploadPhoto,
      uploadPhotoMHD,
      uploadPhotoEMO,
      uploadPhotoMHN,
      uploadPhotoVideoRoom,
      uploadPhotoEDIS
    } = this.appData;

    switch (this.screen.name) {
      case PHOTO_MODAL_SCREEN_NAMES.pulseRavCase: // RAV puls design
        if (action?.value === "changePhoto") {
          inputFileRef.current.click();
        } else {
          uploadPhoto(true);
        }
        break;
      case PHOTO_MODAL_SCREEN_NAMES.ravCase: // RAV flow
        uploadPhoto(true);
        break;
      case PHOTO_MODAL_SCREEN_NAMES.medicalInfoSection:
        uploadPhotoMHD();
        break;
      case PHOTO_MODAL_SCREEN_NAMES.emoCase:
        uploadPhotoEMO();
        break;
      case PHOTO_MODAL_SCREEN_NAMES.mhNavigatorCase:
        uploadPhotoMHN();
        break;
      case PHOTO_MODAL_SCREEN_NAMES.emoCase:
        uploadPhotoEMO();
        break;
      case PHOTO_MODAL_SCREEN_NAMES.mhNavigatorCase:
        uploadPhotoMHN();
      case VIDEO_ROOM_PHOTO_MODAL_SCREEN_NAME:
        const onUploadSuccess = () => {
          this.appData.handleChange({
            [`__${VIDEO_ROOM_PHOTO_MODAL_FIELD_IDENTIFIER}:photoPreview`]: "",
            [`__${VIDEO_ROOM_PHOTO_MODAL_FIELD_IDENTIFIER}:photoName`]: "",
            [`__${VIDEO_ROOM_PHOTO_MODAL_FIELD_IDENTIFIER}:attachment_type_cd`]:
              ""
          });
          this.dialog.hideDialog();
        };

        uploadPhotoVideoRoom(onUploadSuccess, action);
        break;
      case PHOTO_MODAL_SCREEN_NAMES.EliteDiagnosticCase: // EDIS flow
        uploadPhotoEDIS();
        break;
      default:
        break;
    }
  }
}

export default PhotoModalViewController;
